<template>
  <div id="mp-breadcrumb">
    <div class="breadcrumb">
      <div class="breadcrumb_item">
        <!-- <span v-if="index !== 0" class="ivu-breadcrumb-item-separator">/</span> -->
        <!-- <div class="breadcrumb_item"> -->
        <Icon
          :type="breadcrumb[1].menu[breadcrumb[1].active].icon"
          class="item_icon"
        />
        <span class="item_text">{{
          breadcrumb[1].menu[breadcrumb[1].active].text
        }}</span>
      </div>
      <div class="toolFather">
        <slot name="tool"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumb: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>

<style scoped>
#mp-breadcrumb {
  width: 100%;
  color: #2d8cf0;
  font-weight: bold;
}
.breadcrumb {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  /* border-bottom: 1px solid #e8eaec; */
  border-bottom: 1px solid #2d8cf0;
}
.breadcrumb_item {
  position: relative;
  text-align: left;
}
.toolFather {
  float: right;
}
.item_icon {
  padding: 0 5px;
}
.item_text {
  letter-spacing: 2px;
}
</style>
